<template>
	<div class="grid grid-cols-4 gap-2">
		<!-- <div>
      <label class="" for="search">Cerca</label>
      <input type="text" name="search" v-model="filter.search" />
    </div> -->

		<div class="col-span-2">
			<label class="" for="dateRange">Intervallo date</label>
			<t-datepicker
				name="dateRange"
				v-model="dateRange"
				range
				userFormat="d-m-Y"
				:monthsPerView="2"
			></t-datepicker>
		</div>

		<div>
			<label class="" for="operator">Operatore</label>
			<t-select
				name="operator"
				v-model="filter.operator"
				:options="operators"
				text-attribute="fullname"
				vale-attribute="id"
			>
			</t-select>
		</div>

		<div class="">
			<label class="" for="operator">Mostra cancellati</label>
			<t-toggle v-model="filter.deleted" />
		</div>

		<div class="col-span-full">
			<div class="flex justify justify-end">
				<t-button native href="#" @click="fetchInterventions" variant="neutral">
					<span
						>Aggiorna ricerca<i
							class="mx-2 fas fa-sync-alt fa-spin"
							v-show="loading"
						></i>
					</span>
				</t-button>

				<t-button
					native
					href="#"
					@click.prevent="exportInterventions"
					variant="neutral"
                    class="ml-2"
				>
					<span>Esporta interventi </span>
				</t-button>
			</div>
		</div>

		<div class="col-span-2">
			<label for="">Ricerca testo</label>
			<t-input v-model="filter.query" />
		</div>

		<div>
			<label for="">Da revisionare</label><br />
			<t-select
				name="status"
				v-model="filter.status"
				:options="['Tutti', 'Revisionati']"
			>
			</t-select>
		</div>

		<div>
			<label for="">Flag</label><br />
			<t-select name="status" v-model="filter.flag" :options="['Tutti']">
			</t-select>
		</div>

		<div class="col-span-full mt-5">
			<div>
				<a-table
					v-bind:headers="[
						'Numero',
						'Cliente',
						'Data (inizio - fine)',
						'Operatore',
						'Flag',
					]"
					v-bind:data="filteredInterventions"
					v-bind:actions="[
						{
							name: 'review',
							event: 'review',
							icon: 'fa fas fa-check-double',
						},
						{
							name: 'print',
							event: 'print',
							icon: 'fa fas fa-print',
						},
					]"
					@delete="deleteIntervention"
					@edit="
						navigate(
							route('interventions.edit', { intervention: $event.number })
						)
					"
					@review="reviewIntervention"
					@print="printIntervention"
				>
					<template v-slot:row="props">
						<td :class="props.tdClass">
							<span
								class="
									inline-flex
									items-center
									justify-center
									px-2
									py-1
									font-bold
									leading-none
									rounded-full
								"
								:class="
									props.row.reviewed
										? 'text-green-100 bg-green-600'
										: 'text-amber-100 bg-amber-600'
								"
								>{{ props.row.number }}</span
							>
						</td>
						<td :class="props.tdClass">{{ props.row.client.name }}</td>
						<td :class="props.tdClass">
							{{ props.row.date_begin | date }} -
							{{ props.row.date_end | date }}
						</td>
						<td :class="props.tdClass">
							{{ props.row.operator_details.fullname }}
						</td>
						<td :class="props.tdClass">
							<i
								class="fa fas"
								:class="
									props.row.charge_free
										? 'fa-creative-commons-nc-eu'
										: 'fa-euro-sign'
								"
							></i>
							<i
								class="fa fas"
								:class="props.row.draft ? 'fa-pencil-alt' : ''"
							></i>
						</td>
					</template>
				</a-table>
			</div>
			<div class="flex justify justify-center mt-2">
				<div>
					<t-pagination
						:total-items="pagination.totalItems"
						:per-page="pagination.perPage"
						:limit="pagination.limit"
						v-model="pagination.currentPage"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from "moment";
export default {
	data() {
		return {
			filter: {
				query: undefined,
				dateFrom: moment().subtract(1, "months").format("YYYY-MM-DD"),
				dateTo: moment().format("YYYY-MM-DD"),
				operator: undefined,
				deleted: false,
				status: undefined,
				flag: undefined,
			},

			fetch: {
				operators: [],
				interventions: [],
			},

			pagination: {
				totalItems: 0,
				perPage: 20,
				limit: 5,
				currentPage: 1,
			},

			loading: false,
		};
	},

	computed: {
		operators() {
			return [{ id: null, fullname: "Tutti" }, ...this.fetch.operators];
		},

		dateRange: {
			set(value) {
				this.filter.dateFrom = value[0];
				this.filter.dateTo = value[1];
			},

			get() {
				return [this.filter.dateFrom, this.filter.dateTo];
			},
		},
	},

	watch: {
		"pagination.currentPage"() {
			this.fetchInterventions();
		},

		"filter.query"(value) {
			var query = this.filter.query.toLowerCase();
			this.filteredInterventions = this.fetch.interventions.filter(
				(intervention) => {
					return (
						intervention.client.name.toLowerCase().includes(query) ||
						String(intervention.number).includes(query)
					);
				}
			);
		},
	},

	methods: {
		async fetchInterventions() {
			this.fetch.interventions = [];
			this.loading = true;
			var response = await axios.get(
				route("interventions.index", {
					page: this.pagination.currentPage,
					...this.filter,
				})
			);
			if (response.status == 200) {
				let data = response.data.data;
				let meta = response.data.meta;

				this.fetch.interventions = data;
				this.filteredInterventions = data;

				this.pagination.totalItems = meta.total;
				this.pagination.currentPage = meta.current_page;
				this.pagination.perPage = meta.per_page;
			}
			this.loading = false;
		},

		exportInterventions() {
			this.openLink(
				route("export.interventions", {
					...this.filter,
				})
			);
		},

		async fetchOperators() {
			var response = await axios.get(route("operators.index"));
			if (response.status == 200) {
				this.fetch.operators = response.data.data;
			}
		},

		async deleteIntervention(intervention) {
			this.$awn.confirm(
				`Vuoi eliminare l'intervento numero ${intervention.number}?`,
				async () => {
					this.$awn.async(
						axios.delete(
							route("interventions.destroy", {
								intervention: intervention.number,
							})
						),
						(response) => {
							this.fetchInterventions();
							this.$awn.success(`Intervento ${intervention.number} eliminato`);
						},
						(error) => {
							this.$awn.alert(
								"Si è verificato un errore: " + error.response.message
							);
						},
						"Operazione in corso"
					);
				},
				() => {}
			);
		},

		async reviewIntervention(intervention) {
			this.$awn.async(
				axios.put(
					route("interventions.reviewed", { intervention: intervention.number })
				),
				(response) => {
					this.fetchInterventions();
					this.$awn.success(
						`L'intervento ${intervention.number} è stato marcato come revisionato`
					);
				},
				(error) => {
					this.$awn.alert(
						"Si è verificato un errore: " + error.response.message
					);
				},
				"Operazione in corso"
			);
		},

		async printIntervention(intervention) {
			await this.navigate(
				route("interventions.print", { intervention: intervention.number }),
				true
			);
		},
	},

	mounted() {
		this.fetchInterventions();
		this.fetchOperators();
	},
};
</script>
